import Component from '@glimmer/component';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type { KioskDemoPage } from 'garaje/components/homepage/kiosk-demo/provider';

export default class SignInFields extends Component<KioskDemoPage> {
  get shareLink(): string {
    if (this.args.firstFlowId) {
      return `/visitors/settings/visitor-types/${this.args.firstFlowId}`;
    }
    return '/visitors/settings';
  }

  <template>
    <PageTemplate
      @headerTitle="Sign-in fields and logic"
      @headerInfo="Customize the information you collect from visitors by editing your sign-in fields."
      @currentStep={{@currentStep}}
      @totalStepCount={{@totalStepCount}}
      @demoName={{@demoName}}
      @isUserLoggedIn={{@isUserLoggedIn}}
      @isDemoInstance={{@isDemoInstance}}
    >
      <div>
        <ActionItemTemplate
          @header="Add sign-in fields"
          @headerInfo="Customize the questions required for visitors to sign in."
          @subHeader="Available on all plans"
          @iconLink="/assets/images/ipad-demo/icons/graph.svg"
          @iconAlt="Image of sign in flow field"
          @pageLink={{this.shareLink}}
          @isUserLoggedIn={{@isUserLoggedIn}}
          @demoName={{@demoName}}
          @isDemoInstance={{@isDemoInstance}}
        />
      </div>
    </PageTemplate>
  </template>
}
